(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["knity-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('knity-sticky-atc')) {
    customElements.define('knity-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.trigger = this.querySelector('[data-trigger]');
        this.label = this.querySelector('[data-label]');
        this.selection = this.querySelector('[data-selection]');
        this.defaultLabel = this.label.textContent;
        this.abort = new AbortController();
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.sync();
          });
        };
        this.trigger.addEventListener('click', () => this.activate(), { signal: this.abort.signal });
        window.addEventListener('scroll', this.schedule, { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal: this.abort.signal });
        window.addEventListener('kaching-bundles-initialized', this.schedule, { signal: this.abort.signal });
        document.addEventListener('shopify:section:unload', event => {
          if (event.detail.sectionId === this.dataset.section) this.remove();
        }, { signal: this.abort.signal });
        this.info = document.getElementById('MainProduct-' + this.dataset.section);
        if (!this.info) return;
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled', 'aria-busy'] });
        this.moving = true;
        document.body.appendChild(this);
        this.moving = false;
        this.previewResize = new ResizeObserver(this.schedule);
        this.previewMutation = new MutationObserver(this.schedule);
        this.bodyObserver = new MutationObserver(this.schedule);
        this.bodyObserver.observe(document.body, { childList: true });
        this.sync();
      }
      source() {
        return document.getElementById('ProductSubmitButton-' + this.dataset.section);
      }
      ready() {
        return !window.kachingBundlesEnabled || window.kachingBundlesInitialized === true;
      }
      previewOffset() {
        const toolbar = document.getElementById('PBarNextFrameWrapper');
        if (toolbar !== this.previewToolbar) {
          this.previewResize?.disconnect();
          this.previewMutation?.disconnect();
          this.previewToolbar?.removeEventListener('toggle', this.schedule);
          this.previewToolbar = toolbar;
          if (toolbar) {
            this.previewResize.observe(toolbar);
            this.previewMutation.observe(toolbar, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
            toolbar.addEventListener('toggle', this.schedule, { signal: this.abort.signal });
          }
        }
        if (!toolbar) return 0;
        const rect = toolbar.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.height < window.innerHeight / 2
          ? Math.max(0, window.innerHeight - rect.top)
          : 0;
      }
      sync() {
        const source = this.source();
        if (!source || !source.isConnected || !this.info?.isConnected) {
          this.hidden = true;
          return;
        }
        const busy = source.disabled || source.getAttribute('aria-disabled') === 'true' || source.classList.contains('loading');
        this.trigger.disabled = busy || !this.ready() || !!this.locked;
        this.trigger.setAttribute('aria-busy', String(!!this.locked || source.classList.contains('loading')));
        this.label.textContent = source.querySelector('span')?.textContent.trim() || this.defaultLabel;
        const selected = this.info.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-title');
        this.selection.textContent = selected?.textContent.trim() || '';
        this.selection.hidden = !this.selection.textContent;
        this.style.setProperty('--knity-preview-offset', this.previewOffset() + 'px');
        const rect = source.getBoundingClientRect();
        const scrolledPast = window.scrollY > 0 && rect.bottom <= 0;
        this.hidden = !scrolledPast || rect.width === 0 || rect.height === 0;
      }
      activate() {
        const source = this.source();
        if (!source || !this.ready() || this.locked || source.disabled || source.getAttribute('aria-disabled') === 'true') return;
        this.locked = true;
        this.sync();
        source.click();
        clearTimeout(this.unlockTimer);
        this.unlockTimer = setTimeout(() => {
          this.locked = false;
          this.sync();
          const error = this.info.querySelector('.product-form__error-message-wrapper:not([hidden])');
          if (error && error.textContent.trim()) {
            error.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        }, 1200);
      }
      disconnectedCallback() {
        if (this.moving) return;
        this.observer?.disconnect();
        this.previewResize?.disconnect();
        this.previewMutation?.disconnect();
        this.bodyObserver?.disconnect();
        this.abort?.abort();
        clearTimeout(this.unlockTimer);
        cancelAnimationFrame(this.frame);
        this.started = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
